import React, { PropTypes } from 'react';

function ActiveButton(props) {
    return (
        <button type="submit" className={props.buttonClass} onClick={props.onClick} disabled={props.saving || props.disabled}>
            {props.saving && <span>{props.actionLabel} <span className="fa fa-refresh fa-spin fa-fw" /></span>}
            {!props.saving && <span>{props.submitLabel}</span>}
        </button>
    );
}

ActiveButton.propTypes = {
    saving: PropTypes.bool,
    disabled: PropTypes.bool,
    actionLabel: PropTypes.string.isRequired,
    submitLabel: PropTypes.string.isRequired,
    buttonClass: PropTypes.string,
    onClick: PropTypes.func,
};

ActiveButton.defaultProps = {
    buttonClass: 'btn btn-default',
    onClick: () => {},
    saving: false,
    disabled: false,
};

export default ActiveButton;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/activeButton.jsx